// Identifica registros de exceção referentes a NFe/NFCe faltante,
// verificando tanto a classe quanto a mensagem do registro.
export function tipoFaltante(registro) {
  const texto = `${registro?.classe || ''} ${registro?.mensagem || ''}`.toUpperCase();
  if (!texto.includes('FALTANTE')) return null;
  if (texto.includes('NFCE')) return 'NFCe';
  if (texto.includes('NFE')) return 'NFe';
  return null;
}
